<template lang="pug">
    v-container(v-if="tenant")
        .header.d-flex.justify-space-between.align-center.mb-10.white--text
          div
            v-btn.mb-2(outlined, small color="white" @click="$router.go(-1)")
              v-icon.mr-2(small) fas fa-arrow-left
              | Back
            h1 {{tenant.name}}
            //- create-edit-user-dialog(:user="createUser" :edit="false")
        v-row
            v-col(cols='12')
              v-card.elevation-25.d-flex.flex-column(min-height="300")
                v-card-text.d-flex.justify-space-between.flex-no-wrap

                    v-list-item(three-line='' style="margin-right: 130px;")
                      v-list-item-content
                        code.text-normal
                          | {{tenant.id}}
                        v-list-item-title.headline.mb-1
                          | {{tenant.name}}
                          CreateEditTenantDialog(:edit="true", :currentTenant="tenant")
                    img.absoluteImage(v-if="tenant.branding" :src="tenant.branding.logoUrl")
                v-spacer  
                v-card-actions
                      v-chip(:color="tenant.branding.primaryColor" v-if="tenant.branding && tenant.branding.primaryColor" dark) Primary: {{tenant.branding.primaryColor}}
                      v-chip.ml-2(:color="tenant.branding.accentColor" v-if="tenant.branding && tenant.branding.accentColor" dark) Accent: {{tenant.branding.accentColor}}
                      UpdateBrandingDialog(:branding="tenant.branding" :tenantId="$route.params.tenantId" v-if="tenant.branding")
                      v-spacer 
                      v-chip.mr-2(outlined) Created {{formatDateTo(tenant.createdAt, "l")}}
                      v-chip(outlined) Updated {{formatDateTo(tenant.updatedAt, "l")}}

            v-col(cols='12' v-if="$route.params.tenantId" )
              SubscriptionCard(:tenantId="$route.params.tenantId")
            
            v-col(cols='12' v-if="$route.params.tenantId" )
              ThemeSettings(:tenantId="$route.params.tenantId")
                  
            v-col.mt-12(cols='12')
              .header.d-flex.justify-space-between.align-center.mb-4.mt-8
                h2 Users
                CreateEditUserDialog(:tenantId="$route.params.tenantId")
              v-row
                v-col(v-for='user in users' :key='user.Username' cols='12' md="6" xl="4")
                  TenantUserCard(:user="user")
            v-col(cols='12' v-if="$route.params.tenantId" )
              .header.d-flex.justify-space-between.align-center.mb-4.mt-8
                h2 Initial Setup
              TenantSetup(:tenantId="$route.params.tenantId")

             
                  
            
        
        

</template>

<script>
import { mapState } from "vuex";
import ThemeSettings from "@/components/config/ThemeSettings";
import SubscriptionCard from "@/components/account/SubscriptionCard";
import TenantSetup from "@/components/admin/TenantSetup";
import CreateEditUserDialog from "@/components/admin/CreateEditUserDialog";
import CreateEditTenantDialog from "@/components/admin/CreateEditTenantDialog";
import UpdateBrandingDialog from "@/components/admin/UpdateBrandingDialog";
import TenantUserCard from "@/components/admin/TenantUserCard";
import date from "@/utils/date";
export default {
  components: {
    SubscriptionCard,
    CreateEditUserDialog,
    CreateEditTenantDialog,
    UpdateBrandingDialog,
    TenantUserCard,
    TenantSetup,
    ThemeSettings,
  },
  data() {
    return {};
  },
  methods: {
    ...date,
  },
  computed: {
    ...mapState({
      tenants: (state) => state.superAdmin.tenants,
      users: (state) => state.superAdmin.users,
    }),
    tenant() {
      return this.$store.state.superAdmin.tenants.find(
        (tenant) => tenant.id == this.$route.params.tenantId
      );
    },
    users() {
      return this.$store.state.superAdmin.users.filter(
        (user) =>
          user.Attributes["custom:tenantId"] == this.$route.params.tenantId
      );
      // .find(
      //   (user) => user.Attributes.sub == this.$route.params.sub
      // );
    },
  },
  mounted() {
    if (this.tenants.length <= 0) {
      this.$store.dispatch("superAdmin/FETCH_TENANTS");
    }
    if (this.users.length <= 0) {
      this.$store.dispatch("superAdmin/FETCH_USERS");
    }
  },
};
</script>

<style>
.absoluteImage {
  position: absolute;
  top: 20px;
  right: 20px;
  max-width: 200px;
  max-height: 200px;
}
</style>
